import { Link } from 'react-router-dom';
import { useLanguage } from '../../core/hooks/use-language';
import { useTranslation } from '../../core/hooks/use-translation';
import { EmptyState } from '../../ui/empty-state';
import { Panel } from '../../ui/panel';
import { CaseIcon } from '../../ui/portal-icons';
import { CaseCard } from './case-card';
import { usePortalOutlet } from './use-portal-outlet';

/**
 * The portal's first tab. **A customer with no case is the normal state** — an account can exist
 * before any case does — so the empty screen has a way to book on it rather than nothing.
 */
export function CasesTab() {
    const { t } = useTranslation();
    const language = useLanguage();
    const { cases } = usePortalOutlet();

    return (
        <Panel title={t('portal.cases')} icon={<CaseIcon />}>
            {cases.length === 0 ? (
                <EmptyState
                    icon={<CaseIcon />}
                    title={t('portal.empty_title')}
                    action={
                        <Link
                            to={`/${language}/book`}
                            className="inline-flex rounded-xl bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-700"
                        >
                            {t('portal.book_appointment')}
                        </Link>
                    }
                >
                    {t('portal.empty')}
                </EmptyState>
            ) : (
                <ul className="space-y-3">
                    {cases.map((clientCase) => (
                        <CaseCard key={clientCase.id} clientCase={clientCase} />
                    ))}
                </ul>
            )}
        </Panel>
    );
}
